<template>
  <!-- 24.5.16 共用底部 dxm -->
  <div class="footer">
    <div class="footer-main container">
      <img
        style="width: 94px; height: 59px"
        v-if="websiteData.website && websiteData.website.pc_logo"
        :src="websiteData.website.pc_logo"
        alt=""
      />
      <div class="footer-nav">
        <div class="nav-item" v-for="(item, index) in nav" :key="index">
          <!-- v-if="screenWidth > 768 ? item.name_cn : (item.name_cn === '联系我们' ? item.name_cn : '')" -->
          <template>
            <h2 class="title">
              {{ langSet == "cn" ? item.name_cn : item.name_en }}
            </h2>
            <div class="line"></div>
            <div v-for="(_item, _index) in item.children" :key="_index">
              <p class="c-title" v-if="_item.title" :key="_item.title">
                {{ langSet == "cn" ? _item.title : _item.en_title }}
              </p>
              <p
                v-if="langSet == 'cn' && _item.name_cn"
                class="text"
                @click="toLink(_item)"
              >
                <img class="f-icon" v-if="_item.icon" :src="_item.icon" />
                {{ _item.name_cn }}
              </p>
              <p
                v-if="langSet != 'cn' && _item.name_en"
                class="text"
                @click="toLink(_item)"
              >
                <img class="f-icon" v-if="_item.icon" :src="_item.icon" />
                {{ _item.name_en }}
              </p>
              <!-- <div v-for="(_items, _indexs) in _item.children" :key="_indexs">
                <p
                  v-if="langSet == 'cn' && _items.name_cn"
                  class="text"
                  @click="toLink(_items)"
                >
                  <img class="f-icon" v-if="_items.icon" :src="_items.icon" />
                  {{ _items.name_cn }}
                </p>
                <p
                  v-if="langSet != 'cn' && _items.name_en"
                  class="text"
                  @click="toLink(_items)"
                >
                  {{ _items.name_en }}
                </p>
              </div> -->
            </div>
          </template>
        </div>
      </div>
      <div
        class="footer-right"
        v-if="
          websiteData.website &&
          websiteData.website.pc_gzh &&
          websiteData.website.pc_xcx
        "
      >
        <div
          class="footer-img fmright"
          v-if="websiteData.website && websiteData.website.pc_gzh"
        >
          <el-image
            style="width: 95px; height: 95px"
            :src="websiteData.website.pc_gzh"
          ></el-image>
          <div>BCEIA公众号</div>
        </div>
        <!-- <div
          class="footer-img"
          v-if="websiteData.website && websiteData.website.pc_xcx"
        >
          <el-image
            style="width: 95px; height: 95px"
            :src="websiteData.website.pc_xcx"
          ></el-image>
          <div>BCEIA小程序</div>
        </div> -->
      </div>
    </div>
    <div class="footer-copyright">
      <div>
        Copyright @ 2024 Beijing Conference and Exhibition on Instrumental
        Analysis (BCEIA)
      </div>
      <div class="record" v-if="websiteData.copyright">
        <a
          v-for="(item, index) in websiteData.copyright"
          :key="index"
          :href="item.value"
          target="_blank"
          >{{ item.key }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getWebsite, getWebMenu } from "@/api/api";

export default {
  data() {
    return {
      websiteData: {},
      langSet: "",
      nav: [
        // {
        //   title: "关于展会",
        //   en_title: "Exhibition Preface",
        //   sub: [
        //     { title: "BCEIA 2025概况",path: '/about' },
        //     { title: "历届回顾", en_title: "Previous Exhibitions", },
        //     { title: "交通", en_title: "Previous Exhibitions", path:'/exhibitionTraffic' },
        //   ],
        // },
        // {
        //   title: "展商中心",
        //   en_title: "Exhibitor Center",
        //   sub: [
        //     { title: "参展流程", en_title: "Procedures",path:'/exhibitionProcess' },
        //     { title: "参展申请", en_title: "Exhibition Service" },
        //     { title: "展商服务", en_title: "Exhibitor Service" },
        //     { title: "BCEIA金奖", en_title: "" },
        //   ],
        // },
        // {
        //   title: "观众中心",
        //   en_title: "Visitor Center",
        //   sub: [
        //     { title: "观众登记", en_title: "Pre-registration" },
        //     { title: "在线会刊", en_title: "Hotel Information" , path: "/exhibitorList" },
        //     { title: "酒店预订", en_title: "Hotel Information"},
        //   ],
        // },
        // {
        //   title: "媒体中心",
        //   en_title: "Media Center",
        //   sub: [
        //     { title: "BCEIA动态", en_title: "" },
        //     { title: "行业动态", en_title: "" },
        //     { title: "合作媒体", en_title: "" },
        //   ],
        // },
      ],
      screenWidth: 0,
    };
  },
  created() {},
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    console.log(this.langSet, "===langSet");
    this.getWebsite();
    this.getMenu();
  },
  methods: {
    // 获取屏幕宽度和高度的函数
    getScreenSize() {
      return {
        width: window.innerWidth,
      };
    },
    getMenu() {
      let arr = [];
      let data = {
        page_type: 0,
      };
      getWebMenu(data)
        .then((res) => {
          if (res.code == 1) {
            let lists = res.data.lists;
            lists.map((item, index) => {
              if (item.is_bottom == "是") {
                if (
                  item.name_cn == "联系我们" ||
                  item.name_en == "Contact us"
                ) {
                  item.children = [];
                  item.children = [
                    // {
                    //   children: [],
                    //   name_cn: "中国分析测试协会",
                    //   name_en: "China Analysis and Testing Association",
                    //   http_url_cn:
                    //     "https://www.caia.org.cn/v9/main/view/index.aspx",
                    //   http_url_en:
                    //     "https://www.caia.org.cn/v9/main/view/index.aspx",
                    // },
                    // {
                    //   children: [],
                    //   name_cn: "http://www.bceia.cn",
                    //   name_en: "http://www.bceia.cn",
                    //   icon: require("../assets/icon01.png"),
                    //   http_url_cn: "",
                    //   http_url_en: "",
                    // },
                    {
                      title: "展览会",
                      en_title: "Exhibition",
                      name_cn: "+86-010-68512208",
                      name_en: "+86-010-68512208",
                      icon: require("../assets/icon02.png"),
                      http_url_cn: "",
                      http_url_en: "",
                    },
                    {
                      name_cn: "expo@bceia.cn",
                      name_en: "expo@bceia.cn",
                      icon: require("../assets/icon03.png"),
                      http_url_cn: "",
                      http_url_en: "",
                    },
                    {
                      title: "学术报告会",
                      en_title: "Academic Symposium",
                      name_cn: "+86-010-68537066",
                      name_en: "+86-010-68537066",
                      icon: require("../assets/icon02.png"),
                      http_url_cn: "",
                      http_url_en: "",
                    },
                    {
                      name_cn: "conference@bceia.cn",
                      name_en: "conference@bceia.cn",
                      icon: require("../assets/icon03.png"),
                      http_url_cn: "",
                      http_url_en: "",
                    },
                  ];
                }

                arr.push(item);
              }
            });
            this.nav = arr;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getWebsite() {
      let data = {};
      getWebsite(data)
        .then((res) => {
          if (res.code == 1) {
            this.websiteData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //跳转页面
    toLink(item) {
      if (item.http_url_cn || item.http_url_en) {
        if (item.type == "内部跳转") {
          this.$router.push({
            path: this.langSet == "cn" ? item.http_url_cn : item.http_url_en,
          });
        } else {
          let path =
            window.location.protocol + "//" + this.langSet == "cn"
              ? item.http_url_cn
              : item.http_url_en;
          window.open(path, "_blank");
        }
      }
    },
  },
};
</script>

<style lang="scss">
.record a {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #ffffff;
}
.record a:nth-child(1) {
  margin-right: 5px;
}
.footer {
  width: 100%;
  background: #000;
  color: #fff;
  font-size: 18px;
  padding-top: 40px;
  box-sizing: border-box;
  .container {
    width: 1280px;
    margin: 0 auto;
  }
  .footer-main {
    display: flex;
    justify-content: space-between;
    padding-bottom: 36px;
  }
  .footer-nav {
    flex: 1;
    display: flex;
    justify-content: space-between;
    padding: 0 80px 0 86px;
    .nav-item {
      .title {
        font-size: 14px;
      }
      .line {
        width: 24px;
        height: 2px;
        margin-top: 8px;
        margin-bottom: 4px;
        background: rgba(255, 255, 255, 0.7);
        border-radius: 5px;
      }
      .c-title {
        font-size: 14px;
        padding-top: 10px;
        color: rgba(255, 255, 255, 0.9);
      }
      .text {
        font-size: 12px;
        line-height: 17px;
        padding-top: 8px;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: rgba(255, 255, 255, 0.7);
        &:hover {
          color: #fff;
        }
        .f-icon {
          width: 13px;
          margin-right: 8px;
        }
      }
    }
  }
  .footer-right {
    display: flex;
    .footer-img {
      width: 95px;
      font-size: 13px;
      line-height: 18px;
      text-align: center;
    }
  }
  .fmright {
    margin-right: 29px;
  }
  .footer-copyright {
    height: 64px;
    font-size: 12px;
    line-height: 17px;
    text-align: center;
    box-sizing: border-box;
    padding: 16px 0 14px;
    background: #171717;
  }
}

@media only screen and (max-width: 1280px) {
  .footer .container {
    width: 95%;
  }
  .footer .footer-nav {
    padding: 0 2%;
  }
  .fmright {
    margin-right: 10px;
  }
}
@media only screen and (max-width: 767px) {
  .footer-main {
    flex-wrap: wrap;
    justify-content: center;
  }
  .footer .footer-nav {
    display: none;
  }
  .footer-right {
    margin-left: 0.5rem;
  }
  .footer .footer-copyright {
    height: auto;
    padding: 16px 20px 14px;
  }
}
</style>